module.exports = __webpack_public_path__ + "static/img/mJsldBan@2x.fb4f51ab.png";